export default {
  label: '人力资源经理',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '人力资源经理是中层管理职位，负责制定和执行人力资源战略，支持公司业务发展',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '制定并实施招聘计划，完成招聘任务',
          id: '0-2-1',
        },
        {
          label: '负责员工培训与发展计划的制定与实施',
          id: '0-2-2',
        },
        {
          label: '管理员工绩效考核体系，确保公平性和透明性',
          id: '0-2-3',
        },
        {
          label: '协助部门负责人完成企业文化建设',
          id: '0-2-4',
        },
        {
          label: '提供人力资源政策建议，支持业务部门决策',
          id: '0-2-5',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '至少5年以上人力资源相关经验',
          id: '0-3-1',
        },
        {
          label: '熟悉HRIS系统和数据分析工具',
          id: '0-3-2',
        },
        {
          label: '具备良好的沟通能力和领导力',
          id: '0-3-3',
        },
        {
          label: '熟悉劳动法及相关法律法规',
          id: '0-3-4',
        }
      ],
    },
    {
      label: '薪资情况',
      id: '0-4',
      children: [
        {
          label: '25000-35000元',
          id: '0-4-1',
        },
      ],
    }
  ],
};